<template>
    <el-dialog
            :visible="isVisible"
            @close="hide"
            :title="title"
            :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <brand-form
                v-if="isInitialized"
                v-bind="formData"
                @stored="onStored"
        ></brand-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import BrandForm from '../../components/brand/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      BrandForm,
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Brand'
        }

        return 'Create Brand'
      },
    },
    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-brands-table');
      },
    },

    created() {
      eventBus.$on('show-add-brand-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-brand-dialog', this.show);
    }
  }
</script>
